<template>
  <div class="relative h-screen bg-slate-50">
    <div class="mx-auto flex max-w-3xl px-8 py-12 lg:max-w-6xl">
      <div class="w-3/5">
        <div class="max-w-lg lg:max-w-2xl">
          <span class="mb-1 block text-xl text-gray-800 lg:text-lg">#1 industry carbon tracking platform</span>
          <h1
            class="text-3xl font-semibold leading-tight tracking-tight text-gray-800 md:text-5xl lg:text-5xl lg:leading-tight"
          >
            End-to-end seamless carbon accounting platform
          </h1>
        </div>
        <div class="mb-14 max-w-lg">
          <p class="mt-6 text-lg text-gray-500 md:text-base lg:text-base">
            Veridis provides an uncomplicated end-to-end carbon management
            system that helps to account, offset, and track your carbon
            footprint.
          </p>
        </div>
        <div class="flex gap-3 md:space-x-3">
          <button
            type="button"
            class="block select-none rounded-md border-2 border-green-800/50 bg-green-700 px-10 py-4 text-base font-normal text-white hover:bg-green-800 active:bg-green-700 lg:text-sm"
          >
            <span>Request a Demo</span>
          </button>
          <NuxtLink
            to="/"
            class="block select-none rounded-md border border-gray-200 bg-white px-10 py-4 text-base font-normal text-gray-900 hover:bg-gray-100 active:bg-white lg:text-sm"
          >
            <span>Learn More</span>
          </NuxtLink>
        </div>
      </div>
      <div class="relative w-2/5">
        <iframe
          class="absolute -right-60 -top-20"
          src="https://my.spline.design/globe-6f9c59b37842d63903db920f69ccb048/"
          frameborder="0"
          width="600"
          height="600"
        />
      </div>
    </div>
    <div class="absolute bottom-0">
      <NuxtImg
        src="/website/site-divider.svg"
        class="w-full"
        alt="Page divider"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HeroGlobeSection',
}
</script>
